export const mockShowcases = [
  {
    id: 'showcase-1',
    title: 'Kenya Grid-Scale BESS — Phase 2',
    location: 'Nairobi, Kenya',
    region: 'East Africa',
    capacity: 50,
    capacityUnit: 'MWh',
    commissionedYear: 2025,
    offtakeType: 'Utility PPA',
    stage: 'Raising',
    gotfRole: 'Technical Advisory + De-risking',
    openForCollaboration: true,
    openForCoInvestment: true,
    overview: 'Expansion of Kenya\'s first grid-scale BESS to support renewable integration and grid stability.',
    whatWorked: 'Strong utility partnership, clear regulatory framework, and proven Phase 1 track record.',
    lessons: 'Grid connection timelines were underestimated; local capacity building essential.',
    contacts: [
      { name: 'Joseph Mwangi', role: 'Project Lead', email: 'j.mwangi@solararfrica.ke' }
    ],
    technologies: ['BESS'],
    mandateMatch: 96
  },
  {
    id: 'showcase-2',
    title: 'Tanzania Mini-grid Portfolio',
    location: 'Rural Tanzania',
    region: 'East Africa',
    capacity: 22,
    capacityUnit: 'MWh',
    commissionedYear: 2024,
    offtakeType: 'C&I + Utility',
    stage: 'Diligence',
    gotfRole: 'Financing Facilitation',
    openForCollaboration: false,
    openForCoInvestment: true,
    overview: '14 interconnected mini-grids serving rural communities and small businesses.',
    whatWorked: 'Community engagement model and blended finance structure.',
    lessons: 'Tariff design critical; need for ongoing O&M support.',
    contacts: [],
    technologies: ['Mini-grids', 'Solar'],
    mandateMatch: 91
  },
  {
    id: 'showcase-3',
    title: 'Nigeria Interconnected Mini-grids',
    location: 'Delta State, Nigeria',
    region: 'West Africa',
    capacity: 18,
    capacityUnit: 'MWh',
    commissionedYear: 2024,
    offtakeType: 'Community + C&I',
    stage: 'Operational',
    gotfRole: 'Full Project Support',
    openForCollaboration: true,
    openForCoInvestment: false,
    overview: 'How GOTF support de-risked 14 mini-grids in Delta State.',
    whatWorked: 'Local manufacturing partnerships reduced costs by 30%.',
    lessons: 'Regulatory clarity essential for scale; stakeholder alignment takes time.',
    contacts: [
      { name: 'Amara Okafor', role: 'Technical Lead', email: 'a.okafor@ndphc.ng' }
    ],
    technologies: ['Mini-grids'],
    mandateMatch: 0
  }
];
